
import React from 'react';
import { useAuth } from '@/context/AuthContext';

interface SubscriptionDebugInfoProps {
  debugInfo: any;
  userSubscriptionsCount: number;
  loadingSubscriptions: boolean;
}

export function SubscriptionDebugInfo({ 
  debugInfo, 
  userSubscriptionsCount, 
  loadingSubscriptions 
}: SubscriptionDebugInfoProps) {
  // Remove debug info completely from user dashboard
  return null;
}
